const columnAllLists = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
  },
  {
    title: "Nhân viên",
    key: "employee",
    dataIndex: "employee",
    scopedSlots: { customRender: "employee" },
  },
  {
    title: "Ngày bắt đầu",
    key: "startDate",
    dataIndex: "startDate",
    scopedSlots: { customRender: "startDate" },
  },
  {
    title: "Ngày kết thúc",
    key: "endDate",
    dataIndex: "endDate",
    scopedSlots: { customRender: "endDate" },
  },
  // {
  //   title: "Tổng số ngày đi công tác",
  //   key: "totalLeaveDays",
  //   dataIndex: "totalLeaveDays",
  //   scopedSlots: { customRender: "totalLeaveDays" },
  // },
  // {
  //   title: "Tổng số giờ đi công tác",
  //   key: "totalLeaveHours",
  //   dataIndex: "totalLeaveHours",
  //   scopedSlots: { customRender: "totalLeaveHours" },
  // },

  {
    title: "Ngày tạo",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Cập nhật lần cuối",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export { columnAllLists };
